<template>
	<div>
		<modalconfirm ref="modalconfirmAddNonOrder" @action="proccessNonOrder"/>
		<div class="text-h5">Tambah Transaksi Non Order</div>
		<v-card class="mt-3" outlined>
			<v-form ref="formNonOrder" role="form" v-on:submit.prevent="addNonOrder">
				<v-card-text class="pt-2">
					<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
						{{alert.message}}
					</v-alert>
					<v-row>
						<v-col cols="3" md="3">
							<v-autocomplete :items="nonOrderType" label="Jenis" v-model="type" no-data-text="Tidak ada data yang sesuai" :rules="[inputrules.required]" @focus="() => responseError.type=''" :error-messages="responseError.type" class="details-mb-0 text-capitalize" outlined dense hide-details="auto" background-color="white">
								<template v-slot:item="{ item }">
									<span class="text-capitalize">{{item}}</span>
								</template>
								<template v-slot:selection="{ item }">
									<span class="text-capitalize">{{item}}</span>
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="9" sm="6" md="6">
							<v-textarea :rules="[inputrules.required]" v-model="note" label="Catatan" rows="3" height="107" @focus="() => responseError.note=''" :error-messages="responseError.note" hide-details="auto" outlined dense no-resize></v-textarea>
						</v-col>
						<v-col cols="12">
							<v-alert type="error" elevation="1" v-if="responseError.product">
								{{responseError.product}}
							</v-alert>
							<v-simple-table>
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="40%" class="text-left">Nama Produk</th>
											<th width="25%" class="text-left">Kode Produk</th>
											<th width="15%" class="text-left">Jumlah</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in productsSelected" :key="product.product_id">
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletefromNonOrder(index)">
															<v-icon dark>mdi-delete</v-icon>
														</v-btn>
													</template>
													<span>Hapus</span>
												</v-tooltip>
											</td>
											<td>
												<v-autocomplete :items="productsNotSelected" :filter="customFilter" return-object item-text="product_name" v-model="product.data" no-data-text="Tidak ada data yang sesuai" :rules="[productRules]" class="py-3 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-autocomplete>
											</td>
											<td>
												<div class="pt-2">{{ product.data.product_code }}</div>
											</td>
											<td>
												<v-currency-field v-model.lazy="product.data.quantity" :rules="[inputrules.required, inputrules.notnull]" outlined dense hide-details="auto" background-color="white" class="py-3 details-mb-0"></v-currency-field>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="px-4 pb-4">
					<v-btn light depressed color="primary" @click="addProduct">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Produk</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" depressed class="text-capitalize" type="submit" v-if="productsSelected.length > 0">Proses</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			nonOrderType: ['compliment', 'officer check'],
			type: '',
			menu: false,
			note: '',
			productsSelected: [],
			productRules: value => !!value.product_id || 'Tidak boleh kosong',
		}
	},
	computed: {
		...mapState('nonOrder', ['listProduct', 'response', 'responseError', 'alertMultiple']),

		productsNotSelected() {
			if (this.productsSelected.length > 0) {
				const productSelected = this.productsSelected.map((el) => el.data)
				return this.listProduct.map((el) => {
					if (productSelected.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.listProduct
		},
	},
	methods: {
		...mapActions('nonOrder', ['createNonOrder','getOptionProduct']),
		...mapMutations('nonOrder', ['saveResponse']),
		...mapMutations(['setOverlay']),

		customFilter (item, queryText) {
			const textOne = item.product_code.toLowerCase()
			const textTwo = item.product_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
		addProduct() {
			this.responseError.product = ''
			this.productsSelected.push({
				data: {
					product_id: '',
					product_name: '',
					quantity: '0',
				},
			})
		},
		deletefromNonOrder(index) {
			this.productsSelected.splice(index, 1)
		},
		addNonOrder() {
			if (this.$refs.formNonOrder.validate()) {
				this.$refs.modalconfirmAddNonOrder.setMessage('Apakah Anda yakin akan melakukan Transfer Non Order?')
				this.$refs.modalconfirmAddNonOrder.showConfirm()
			}
		},
		async proccessNonOrder() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmAddNonOrder.hideConfirm()
			let product = await this.productsSelected.map( (el) => {
				return {
					product_name: el.data.product_name,
					product_id: el.data.product_id,
					quantity: el.data.quantity,
					price: el.data.price
				}
			})
			let params = await {
				product: product,
				type: this.type,
				note: this.note
			}
			await this.createNonOrder(params).then(() => {
				if (this.response.code == 200.) {
					this.resetForm()
				}
			})
			await this.setOverlay(false)
		},
		resetForm() {
			this.saveResponse('')
			this.$refs.formNonOrder.resetValidation()
			this.type = ''
			this.note = ''
			this.productsSelected = []
			this.getOptionProduct({limit:100})
		}
	},
	created() {
		this.date = this.today
		this.$store.dispatch('setPageTitle', `Tambah Transaksi Non Order`)
		this.getOptionProduct({limit:100})
	},
	watch: {
	}
}
</script>